export default "__VITE_ASSET__RHy1dsHx__"